// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"272":"admin-login","605":"shop-verify-success","806":"user","883":"shop","884":"admin"}[chunkId] + "." + {"272":"ebfe1a20","605":"294f75d8","806":"3a4f6a09","883":"77781403","884":"959374e9"}[chunkId] + ".css";
};